import moment from "moment";
import { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useMutation } from "react-query";
import Card from "../../../components/Card";
import { OptionModel, OverviewRes } from "../../../models";
import { httpGET } from "../../../utils/ajaxHelper";
import { Container, CountItemCus } from "./overview.styled";


export interface OverviewProps {
    interval: number;
    isAllowMobile: boolean;
    orgFilter?: OptionModel;
}
export const Overview = ({ interval, isAllowMobile = true, orgFilter }: OverviewProps) => {
    const [overview, setOverview] = useState<OverviewRes>();
    const { mutate: overviewFetch } = useMutation(
        (interval: number) =>
            httpGET({
                url: "/DashboardReport/overview",
                params: {
                    interval: interval,
                    timeZone: new Date().getTimezoneOffset() / (-60),
                    currentDate: moment().format("MM/DD/YYYY").toString(),
                    orgId: orgFilter?.value
                }
            }),
        {
            onSuccess: (rs) => {
                setOverview(rs);
            },
        },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { overviewFetch(interval) }, [interval, orgFilter]);

    if (!overview) { return null; }

    return (<Container isAllowMobile={isAllowMobile}>
        <Card className="card-container">
            <h2>
                Search Views
            </h2>
            <CountItemCus isAllowMobile={isAllowMobile}>
                <div className={`${isAllowMobile ? "" : "mb-[20px]"} roll-num`}>
                    <CountUp duration={1} className="counter" end={overview.numberOfSearch} />
                </div>
                <div className="percent">
                    <span className={(isAllowMobile ? "" : "mr-[10px]")}>
                        +<CountUp decimal="." decimals={2} duration={1} className="counter" end={overview.numberOfSearchRatio} />%
                    </span>
                    <span className={(isAllowMobile ? "ml-[10px]" : "mt-[8px]")}>
                        <UpIcon />
                    </span>
                </div>
            </CountItemCus>
        </Card>
        <Card className="card-container">
            <h2>
                Profile Views
            </h2>
            <CountItemCus isAllowMobile={isAllowMobile}>
                <div className={`${isAllowMobile ? "" : "mb-[20px]"} roll-num`}>
                    <CountUp duration={1} className="counter" end={overview.profileViews} />
                </div>
                <div className="percent">
                    <span className={(isAllowMobile ? "" : "mr-[10px]")}>
                        +<CountUp decimal="." decimals={2} duration={1} className="counter" end={overview.profileViewsRatio} />%
                    </span>
                    <span className={(isAllowMobile ? "ml-[10px]" : "mt-[8px]")}>
                        <UpIcon />
                    </span>
                </div>
            </CountItemCus>
        </Card>
        <Card className="card-container">
            <h2>
                Inquiries Received
            </h2>
            <CountItemCus isAllowMobile={isAllowMobile}>
                <div className={`${isAllowMobile ? "" : "mb-[20px]"} roll-num`}>
                    <CountUp duration={1} className="counter" end={overview.messagesReceived} />
                </div>
                <div className="percent">
                    <span className={(isAllowMobile ? "" : "mr-[10px]")}>
                        +<CountUp decimal="." decimals={2} duration={1} className="counter" end={overview.messagesReceivedRatio} />%
                    </span>
                    <span className={(isAllowMobile ? "ml-[10px]" : "mt-[8px]")}>
                        <UpIcon />
                    </span>
                </div>
            </CountItemCus>
        </Card>
        <Card className="card-container">
            <h2>
                Inquiries Sent
            </h2>
            <CountItemCus isAllowMobile={isAllowMobile}>
                <div className={`${isAllowMobile ? "" : "mb-[20px]"} roll-num`}>
                    <CountUp duration={1} className="counter" end={overview.messagesSent} />
                </div>
                <div className="percent">
                    <span className={(isAllowMobile ? "" : "mr-[10px]")}>
                        +<CountUp decimal="." decimals={2} duration={1} className="counter" end={overview.messagesSentRatio} />%
                    </span>
                    <span className={(isAllowMobile ? "ml-[10px]" : "mt-[8px]")}>
                        <UpIcon />
                    </span>
                </div>
            </CountItemCus>
        </Card>
    </Container>)
}


const UpIcon = () => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={17}
        height={16}
        viewBox="0 0 17 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.95488 5.60777L14.5 4L13.1198 9.6061L11.398 7.9532L8.62069 10.8463C8.52641 10.9445 8.39615 11 8.26 11C8.12385 11 7.99359 10.9445 7.89931 10.8463L5.86 8.72199L2.86069 11.8463C2.66946 12.0455 2.35294 12.0519 2.15373 11.8607C1.95453 11.6695 1.94807 11.3529 2.13931 11.1537L5.49931 7.65373C5.59359 7.55552 5.72385 7.5 5.86 7.5C5.99615 7.5 6.12641 7.55552 6.22069 7.65373L8.26 9.77801L10.6766 7.26067L8.95488 5.60777Z"
            fill="#0971A2"
        />
    </svg>
}

const DownIcon = () => {
    return <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.3463 3.63931C14.5455 3.83054 14.5519 4.14706 14.3607 4.34627L11.0007 7.84627C10.9064 7.94448 10.7761 8 10.64 8C10.5039 8 10.3736 7.94448 10.2793 7.84627L8.24 5.72199L5.82335 8.23933L7.54513 9.89223L2 11.5L3.38019 5.8939L5.10197 7.5468L7.87931 4.65373C7.97359 4.55552 8.10385 4.5 8.24 4.5C8.37615 4.5 8.50641 4.55552 8.60069 4.65373L10.64 6.77801L13.6393 3.65373C13.8305 3.45453 14.1471 3.44807 14.3463 3.63931Z"
            fill="#1C1C1C"
        />
    </svg>

}